import React from 'react';

const Settings = () => {
  return (
    <div className="max-w-3xl mx-auto space-y-6 animate-fadeIn">
      <div>
        <h1 className="text-3xl font-bold text-white tracking-tight">Platform Settings</h1>
        <p className="text-gray-400 text-sm mt-1">Configure global trial variables, threshold limits, and scanner timing heartbeats.</p>
      </div>

      <div className="bg-[#0F172A] border border-[#1E293B] rounded-xl shadow-lg p-6 lg:p-8 space-y-6">
        <h3 className="text-sm font-bold text-[#6CD800] uppercase tracking-wider border-b border-[#1E293B] pb-2 mb-4">Global Parameters</h3>
        <div className="space-y-4">
          <div className="flex justify-between items-center py-2 border-b border-[#1E293B]">
            <span className="text-sm font-medium text-white">Default Trial Period Length</span>
            <span className="text-sm font-bold text-gray-300">14 Days</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-[#1E293B]">
            <span className="text-sm font-medium text-white">Heartbeat Offline Threshold</span>
            <span className="text-sm font-bold text-gray-300">30 Minutes</span>
          </div>
          <div className="flex justify-between items-center py-2">
            <span className="text-sm font-medium text-white">Ad Completed Skip Rate %</span>
            <span className="text-sm font-bold text-gray-300">80%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
